import * as global from '../globals';
import * as apiService from '../utils/apiService';
import { getClerkToken } from '../utils/clerkToken';
import { RootState } from './RootState';

import {
    AUTH_REQUEST_TOKEN,
    AUTH_RENEW_TOKEN,
    AUTH_CLEAR_TOKEN,
    AUTH_CLEAR_MESSAGES,
    AUTH_STORE_TOKEN,
    AUTH_LOGOUT,
    AUTH_REQUEST_RESET,
    AUTH_STORE_SCROLL_POS,
    AUTH_UPDATE_SCROLL_POS,
    AUTH_SET_CLERK_STATUS,
    AUTH_HYDRATED
    // @ts-ignore
} from './action-types';


export interface AuthState {

    auth_fetch_status: any;

    token: string;

    studies: AuthStudyState[];

    user: AuthUserState;

    scrollPos: any[];

    isLoaded: boolean;

    isSignedIn: boolean;

    hydrated: boolean;

}

interface AuthUserState {

    id: string;

    name: string;

    company: string;

    userFilter: string;

    accountId: number;

    isAccountAdmin: boolean;

    isSuperAdmin: boolean;

}

interface AuthStudyState {

    uid: string;

    label: string;

    groupLabel: string;

    isStudyAdmin: boolean;

    channels: AuthStudyChannelState[];

    studySpecificItems: any;

}

interface AuthStudyChannelState{

    key: string;

    label: string;

    read: boolean;

    write: boolean;

}



const initialState: AuthState = {
    auth_fetch_status: {
        fetching: false,
        fetchMessage: null,
        errorMessage: null,
        successMessage: null
    },

    token: '',
    studies: [],
    user: {
        id: '',
        name: '',
        company: '',
        userFilter: '',
        accountId: -1,
        isAccountAdmin: false,
        isSuperAdmin: false

    },
    scrollPos: [],
    isLoaded: false,
    isSignedIn: false,
    hydrated: false
};




export const actionCreators = {

    changePassword: (body: any, callback: any) => async (dispatch: any, getState: any) => {

        const state:RootState = getState();

        try {

            const url = `${global.apiRoot}/account/change-password`;
            const response = await apiService.aPost(state.auth, url, body);

            if( response.ok ){
                const res = await response.json();
                if( callback ) callback(res, false);
            }
            else{
                console.log(response);
                if( callback ) callback(null, true);
            }

        } catch (error) {
            console.log(error);
        }

    },

    uploadAvatar: (data: any, callback: any) => async (dispatch: any, getState: any) => {

        try {
            const token = await getClerkToken();
            const url = `${global.appRoot}/avatar`;
            const response = await fetch(url, {
                method: 'POST',
                body: data,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            });

            if( response.ok ){
                const res = await response.json();
                if( callback ) callback(res, false);
            }
            else{
                console.log('error => ', response.statusText);
                if( callback ) callback(null, true);
            }

        } catch (error) {
            console.log(error);
        }

    },

    clearMessages: () => async (dispatch: any, __: any) =>
        dispatch({ type: AUTH_CLEAR_MESSAGES }),

    _stripTemp: (auth:any) => ({
        ...auth,
        auth_fetch_status: undefined
    }),

    setClerkStatus: (isLoaded: boolean, isSignedIn: boolean) => (dispatch: any) => {
        dispatch({ type: AUTH_SET_CLERK_STATUS, isLoaded, isSignedIn });
    },

    hydrateFromClerk: () => async (dispatch: any) => {
        dispatch({ type: AUTH_REQUEST_TOKEN });
        try {
            const response = await apiService.aGet(null, `${global.apiRoot}/auth/me`);
            if (!response.ok) {
                const text = await response.text();
                dispatch({
                    type: AUTH_STORE_TOKEN,
                    auth: {
                        ...initialState,
                        isLoaded: true,
                        isSignedIn: true,
                        hydrated: false,
                        auth_fetch_status: {
                            ...initialState.auth_fetch_status,
                            errorMessage: text || `hydrate failed (${response.status})`
                        }
                    }
                });
                return;
            }
            const json = await response.json();
            dispatch({
                type: AUTH_HYDRATED,
                user: json.user,
                studies: json.studies,
                webclient_version: json.webclient_version
            });
        } catch (reason) {
            console.error('hydrateFromClerk failed', reason);
            dispatch({
                type: AUTH_STORE_TOKEN,
                auth: {
                    ...initialState,
                    isLoaded: true,
                    isSignedIn: true,
                    hydrated: false,
                    auth_fetch_status: {
                        ...initialState.auth_fetch_status,
                        errorMessage: 'Unexpected error: ' + reason
                    }
                }
            });
        }
    },

    logoutUser: () => async (dispatch: any) => {
        localStorage.removeItem('auth')
        var auth: any = {
            ...initialState,
            user: null,
            token: null
        }
        dispatch({ type: AUTH_LOGOUT, auth: auth })
    },

    signUp: (
        email: string,
        name: string,
        company: string,
        studycode: string,
        g_recaptcha_response: string) => async (dispatch: any, getState: any) => {

        dispatch({
            type: AUTH_STORE_TOKEN,
            auth: {
                ...initialState,
                auth_fetch_status: {
                    ...initialState.auth_fetch_status,
                    fetching: true,
                    fetchMessage: 'Please wait: submitting'
                }
            }
        });

        var auth = { ...initialState };

        try {
            apiService.aPost(null, `${global.apiRoot}/account/create-account`, {
                email,
                name,
                company,
                studycode,
                g_recaptcha_response
            })
                .then(response => response.json())
                .then(json => {
                    auth.auth_fetch_status.successMessage = json.success ? json.message : null;
                    auth.auth_fetch_status.errorMessage = json.success ? null : json.errorMessage;
                });
        } catch (reason) {
            auth.auth_fetch_status.errorMessage = reason;
        }

        dispatch({ type: AUTH_STORE_TOKEN, auth });
    }
};

export const reducer = (state: AuthState = initialState, action: any): AuthState => {

    switch (action.type) {
        case AUTH_RENEW_TOKEN :
            return {
                ...state,
                auth_fetch_status: {
                    fetching: true,
                    fetchMessage: 'renewing auth token'
                }
            };

        case AUTH_REQUEST_TOKEN :
            return {
                ...state,
                auth_fetch_status: {
                    fetching: true,
                    fetchMessage: 'requesting access'
                }
            };

        case AUTH_CLEAR_TOKEN :
            return {
                ...state,
                auth_fetch_status: {
                    fetching: true,
                    fetchMessage: 'clearing auth token'
                }
            };

        case AUTH_CLEAR_MESSAGES:
            return {
                ...state,
                auth_fetch_status: null
            }

        case AUTH_STORE_TOKEN:
            return {
                ...state,
                ...action.auth
            }

        case AUTH_SET_CLERK_STATUS:
            return {
                ...state,
                isLoaded: !!action.isLoaded,
                isSignedIn: !!action.isSignedIn
            }

        case AUTH_HYDRATED:
            return {
                ...state,
                user: action.user,
                studies: action.studies,
                hydrated: true,
                auth_fetch_status: {
                    fetching: false,
                    fetchMessage: null,
                    errorMessage: null,
                    successMessage: null
                }
            }

        case AUTH_LOGOUT:
            return {
                ...state,
                ...action.auth,
                isLoaded: state.isLoaded,
                isSignedIn: false,
                hydrated: false
            }

        case AUTH_REQUEST_RESET :
            return {
                ...state,
                auth_fetch_status: {
                    fetching: true,
                    fetchMessage: 'Please wait: resetting'
                }
            };

        case AUTH_STORE_SCROLL_POS :
            let {scrollPos} = state, f = 0;

            scrollPos.forEach((i: any) => {
                if (i.pathname === action.value.pathname) {
                    i.scroll = action.value.scroll;
                    ++f;
                }
            });

            if (f === 0 && action.value.scroll[1] > 0) scrollPos.push(action.value)

            return {
                ...state,
                scrollPos: scrollPos
            };

        case AUTH_UPDATE_SCROLL_POS :
            return {
                ...state,
                scrollPos: [...action.value]
            }


        default:
            return state;
    }
};
